<template lang="pug">
    v-dialog( v-model="dialog"  width="52%" overflow-y="initial" overflow-x="initial" style="z-index:999999;")
        v-overlay(:value="overlay")
            v-progress-circular(indeterminate size="64")

        template( v-if="user_id === 0" v-slot:activator="{ on}")
            v-btn( @click="registerUser()" color="amber") Try for free

        template()
            PaymentView(:value="dialog")
</template>

<script>
import PaymentView from "./PaymentView.vue";
import { mapMutations } from "vuex";

export default {
    name: "UserPricePlans",
    components: {
        PaymentView
    },
    props: {
        value: Boolean,
        from: String,
    },
    data () {
        return {
            dialog: false,
            overlay: false,
        }
    },
    computed: {
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        registerUser() {
            this.setRegisterType('signup');
            this.setRegisterWindows(true);
        }
    }
}
</script>

<style scoped>

</style>
